// extracted by mini-css-extract-plugin
export default {"contentWrapper":"DividerContent2_contentWrapper__X9Vzs","divider":"DividerContent2_divider__gm4zd"};